module.exports = __webpack_public_path__ + "img/76ne.59e690be.svg";